import React, { useState, useRef, useEffect } from 'react';
// import { useDispatch, useSelector } from 'react-redux'
// import { domainUrl } from '../../dummyData';

import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';

export default function Departments() {
    // const { loading, user, error, success, successMessage } = useSelector((state) => state.persist.user)
    // const dispatch = useDispatch();


    const [flagData, setFlagData] = useState([
        // {id: 1, name: 'app_email', value: 'info@nextlevel-football.com'},
    ]);

    useEffect(() => {

        // let url =  `${domainUrl}/guest_flags`

        // fetch(url)
        // .then(response => {
        //   return response.json()
        // })
        // .then(data => {
        //   // console.log('tee', data.data)
        //   setFlagData(data.data)
        // })
    }, [])


    return (
        // loading ? (
        //   <div className="loader-container">
        //       <div className="spinner"></div>
        //       {/* <h6 style={{color: 'white', textAlign:'center'}}>loading please wait...</h6> */}
        //   </div>
        // ) :
        <>
        <Header page={'department'}/>

        {/* <!-- Team Start --> */}
        <div className="container-fluid team py-5">
            <div className="container py-5">
                <div className="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s" style={{maxWidth: '800px'}}>
                    <h4 className="" style={{color: 'gold'}}>Our Trainer</h4>
                    <h1 className="display-4 mb-4">Meet Our Amazing Team</h1>
                    <p className="mb-0">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tenetur adipisci facilis cupiditate recusandae aperiam temporibus corporis itaque quis facere, numquam, ad culpa deserunt sint dolorem autem obcaecati, ipsam mollitia hic.
                    </p>
                </div>
                <div className="row gy-5 gy-lg-4 gx-4">
                    <div className="col-md-6 col-lg-3 wow fadeInUp" data-wow-delay="0.2s">
                        <div className="team-item">
                            <div className="team-img">
                                <img src="./assets/img/soft.png" className="img-fluid w-100" alt="Image"/>
                                <div className="team-icon">
                                    <a href="#" className="btn btn-primary btn-sm-square"><i className="fab fa-facebook-f"></i></a>
                                    <a href="#" className="btn btn-primary btn-sm-square"><i className="fab fa-twitter"></i></a>
                                    <a href="#" className="btn btn-primary btn-sm-square"><i className="fab fa-instagram"></i></a>
                                    <a href="#" className="btn btn-primary btn-sm-square"><i className="fab fa-linkedin-in"></i></a>
                                </div>
                            </div>
                            <div className="team-content">
                                <h4>Trainer Name</h4>
                                <p className="mb-0">Profession</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-3 wow fadeInUp" data-wow-delay="0.4s">
                        <div className="team-item">
                            <div className="team-img">
                                <img src="./assets/img/soft.png" className="img-fluid w-100" alt="Image"/>
                                <div className="team-icon">
                                    <a href="#" className="btn btn-primary btn-sm-square"><i className="fab fa-facebook-f"></i></a>
                                    <a href="#" className="btn btn-primary btn-sm-square"><i className="fab fa-twitter"></i></a>
                                    <a href="#" className="btn btn-primary btn-sm-square"><i className="fab fa-instagram"></i></a>
                                    <a href="#" className="btn btn-primary btn-sm-square"><i className="fab fa-linkedin-in"></i></a>
                                </div>
                            </div>
                            <div className="team-content">
                                <h4>Trainer Name</h4>
                                <p className="mb-0">Profession</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-3 wow fadeInUp" data-wow-delay="0.6s">
                        <div className="team-item">
                            <div className="team-img">
                                <img src="./assets/img/soft.png" className="img-fluid w-100" alt="Image"/>
                                <div className="team-icon">
                                    <a href="#" className="btn btn-primary btn-sm-square"><i className="fab fa-facebook-f"></i></a>
                                    <a href="#" className="btn btn-primary btn-sm-square"><i className="fab fa-twitter"></i></a>
                                    <a href="#" className="btn btn-primary btn-sm-square"><i className="fab fa-instagram"></i></a>
                                    <a href="#" className="btn btn-primary btn-sm-square"><i className="fab fa-linkedin-in"></i></a>
                                </div>
                            </div>
                            <div className="team-content">
                                <h4>Trainer Name</h4>
                                <p className="mb-0">Profession</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-3 wow fadeInUp" data-wow-delay="0.8s">
                        <div className="team-item">
                            <div className="team-img">
                                <img src="./assets/img/soft.png" className="img-fluid w-100" alt="Image"/>
                                <div className="team-icon">
                                    <a href="#" className="btn btn-primary btn-sm-square"><i className="fab fa-facebook-f"></i></a>
                                    <a href="#" className="btn btn-primary btn-sm-square"><i className="fab fa-twitter"></i></a>
                                    <a href="#" className="btn btn-primary btn-sm-square"><i className="fab fa-instagram"></i></a>
                                    <a href="#" className="btn btn-primary btn-sm-square"><i className="fab fa-linkedin-in"></i></a>
                                </div>
                            </div>
                            <div className="team-content">
                                <h4>Trainer Name</h4>
                                <p className="mb-0">Profession</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {/* <!-- Team End --> */}

        <Footer/>
        </>
    );
}
